import { FormattedMessage } from 'react-intl';
import { RelationshipToPrimaryApplicant } from '@api/btlApplicationForm/types';

// Labels are keyed by the enum's array position, so this mapping must exist in exactly one
// place — a second copy would silently drift if anyone reorders RelationshipToPrimaryApplicant.
export function relationshipToPrimaryApplicantOptions() {
  return Object.values(RelationshipToPrimaryApplicant).map((type, index) => ({
    label: (
      <FormattedMessage id={`btlApplicationForm.APPLICANTS_INDIVIDUAL.relationshipToPrimaryApplicant.${index}.label`} />
    ),
    value: type,
  }));
}
